"use strict";
/*

This can be used if you need a screen reader to read out something when an action happens, that is not visible
content on the screen. For example if you needed the screen reader to read out "5 results found" when searching
you can use this function.

usage:...

const {sayPolitely} = useAnnouncement();

handleOnEvent: () => {
    sayPolitely("Well hello there")
}
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAnnouncement = void 0;
var setAnnouncement = function () {
    var div;
    var sayPolitely = function (message) {
        div = document.createElement("div");
        div.setAttribute("role", "alert");
        div.setAttribute("aria-live", "polite");
        div.textContent = message;
        div.style.position = "absolute";
        div.style.top = "-100vh";
        document.body.append(div);
        window.setTimeout(function () {
            try {
                if (div) {
                    document.body.removeChild(div);
                }
            }
            catch (err) {
                /* ignore this error */
            }
        }, 5000);
    };
    return {
        sayPolitely: sayPolitely,
    };
};
exports.setAnnouncement = setAnnouncement;
